<template>
  <div>
    <div style="width:1240px;margin: 0 auto;">
      <HeadTop />
    </div>
    <div style="background:#fff;">
      <div class="home">
        <a-spin class="load" v-show="loading" />
        <div class="selectMain">
          <div class="selectLeft">
            <span :class="selectCurrentMain==index?'spanActiveMain':'spanText'"
                  v-for="(item, index) in selectType" :key="item.key"
                  @click="searchSelectMain(index,item)">{{item.title}}</span>
          </div>
        </div>
        <div class="select">
          <div class="selectLeft">
            <span :class="selectCurrent==index?'spanActive':'spanText'" v-for="(item, index) in selectSearch"
                  :key="item.key" @click="searchSelect(index,item)">{{item.name}}</span>
          </div>
        </div>
        <div class="empty" v-if='list.length==0'>
          <a-empty></a-empty>
        </div>
        <ul class="activeList" v-else>
          <li class="activeLi" @click="watchNowFun(item)" v-for="(item, index) in list" :key="index">
            <div class="imgDetail">
              <img class="imgTop" v-if="item.fileList&&item.fileList!=null"
                   :src="resBasePath+'/'+item.fileList[0].coverPath" alt="">
            </div>
            <ul class="activeDesc">
              <li>
                <span class="title">{{item.title}}</span>
                <!-- <img v-if="item.isPayment==0" class="freeImg" width="18px" height="18px" src="../../assets/img/free.png" alt=""> -->
              </li>
              <li>
                <a-tooltip placement="top" :title="item.authorInfo">
                  <div class="titleName">{{item.author}} {{item.authorInfo}}</div>
                </a-tooltip>
              </li>
              <li>
                <a-icon type="aliwangwang" />
                <span class="watchNum">{{item.playCount}}人已经观看</span>
                <span class="watchNow">立即观看</span>
              </li>
            </ul>
          </li>
        </ul>
        <div style="text-align:center;margin-top:20px;height:50px;">
          <a-config-provider>
            <a-pagination show-quick-jumper :default-current="pageNum" :page-size="pageSize"
                          @change="handleListChange" show-less-items :total=total />
          </a-config-provider>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeadTop from '@/components/HeadTop.vue';
import axios from 'axios';
export default {
  name: 'snailVideoList',
  data() {
    return {
      loading: false,
      pageSize: 16,
      pageNum: 1,
      list: [],
      selectCurrent: 0,
      selectCurrentMain: 0,
      selectType: [],
      selectSearch: [
        { name: '全部直播', key: '' },
        { name: '免费直播', key: 0 },
        // {name: '未开始', key: '2'},
        { name: '付费直播', key: 1 },
      ],
      isPayment: '',
      liveStatus: '',
      total: 0,
      resBasePath: this.$resBasePath,
      mediaCategoryId: '', // 分类
    };
  },
  mounted() {
    this.getCategory();
    this.pageNum = sessionStorage.getItem('videoPageNum')
    this.getList();

  },
  methods: {
    // ebook/teacher/live/getMediaCategoryList
    getCategory() {
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/live/getMediaCategoryList',
        body: {},
      }).done((res) => {
        if (res && res.success && res.resultCode === 0) {
          this.selectType = res.resultData;
          this.selectType.unshift({ title: '全部', id: '' });
        }
      });
    },
    getList() {
      const params = {
        isPayment: this.isPayment,
        mediaCategoryId: this.mediaCategoryId,
        pageSize: this.pageSize,
        pageNum: this.pageNum,
      };
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/live/getMediaPage',
        body: params,
      })
        .loading(
          () => (this.loading = true),
          () => (this.loading = false)
        )
        .done((res) => {
          // console.log(res)
          if (res && res.success && res.resultCode === 0) {
            this.list = res.resultData.list;
            this.total = res.resultData.total;
          }
        });
    },
    searchSelect(index, item) {
      this.selectCurrent = index;
      this.isPayment = item.key;
      this.getList();
    },
    searchSelectMain(index, item) {
      this.selectCurrentMain = index;
      this.mediaCategoryId = item.id;
      this.getList();
    },
    handleListChange(current, pageSize) {
      this.pageNum = current;
      this.pageSize = pageSize;
      this.getList();
    },
    onChange() {},
    watchNowFun(item) {
      this.watch(item);
      sessionStorage.setItem('videoDetail', JSON.stringify(item));
      sessionStorage.setItem('videoPageNum', this.pageNum);
      this.$router.push({ name: 'snailVideoDetail' });
    },
    watch(item) {
      this.$fetch({
        url: this.$httpConfig.saveMediaPlayCount,
        body: {
          id: item.id,
        },
      })
        .loading(
          () => (this.loading = true),
          () => (this.loading = false)
        )
        .done((res) => {
          if (res && res.success && res.resultCode == 0) {
            this.loading = false;
          }
        });
    },
  },
  components: {
    HeadTop,
  },
};
</script>

<style scoped lang="less">
ul,
li {
  list-style: none;
  margin: 0;
  padding: 0;
}
.home {
  width: 1240px;
  margin: auto;
  background: #fff;
  position: relative;
  .load {
    position: absolute;
    top: 25%;
    left: 50%;
    transform: translate(50%, 50%);
    z-index: 99;
  }
  .selectMain {
    height: 60px;
    line-height: 60px;
    width: 100%;
    display: flex;
    .selectLeft {
      display: flex;
      cursor: pointer;
      margin-top: 18px;
      width: 100%;
      border-bottom: 1px solid #e6ddd0;
      .spanText {
        display: inline-block;
        width: 120px;
        height: 24px;
        line-height: 24px;
        color: #000;
        font-size: 14px;
        text-align: center;
      }
    }
  }
  .select {
    height: 30px;
    width: 100%;
    display: flex;
    margin-top: 10px;
    .selectLeft {
      display: flex;
      cursor: pointer;
      .spanText {
        display: inline-block;
        width: 100px;
        height: 32px;
        line-height: 32px;
        color: #000;
        font-size: 14px;
        text-align: left;
      }
    }
    .border {
      width: 60px;
      height: 20px;
      border-left: 1px solid #7f7f7f;
      margin-top: 5px;
    }
    .selectRight {
      margin-top: 5px;
    }
  }
  .activeList {
    margin-top: 10px;
    display: flex;
    flex-wrap: wrap;
    min-height: 500px;
    .activeLi {
      width: calc(25% - 10px);
      height: 280px;
      margin: 10px 10px 0px 0px;
      box-shadow: 0px 2px 20px 0px rgba(219, 206, 188, 0.3);
      .imgDetail {
        height: 160px;
        .imgTop {
          width: 100%;
          height: 100%;
          display: block;
        }
      }
      .activeDesc {
        margin-top: 10px;
        padding: 0px 10px;
        .title {
          display: inline-block;
          width: 180px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          height: 26px;
          font-size: 16px;
          font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi;
          font-weight: 500;
          color: #000000;
          line-height: 26px;
        }
        .freeImg {
          width: 25px;
          height: 20px;
          margin-top: 2px;
          float: right;
        }
        .titleName {
          height: 35px;
          font-size: 12px;
          font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
          font-weight: 400;
          color: #000000;
          line-height: 35px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .watchNum {
          height: 18px;
          font-size: 12px;
          font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
          font-weight: 400;
          color: #7f7f7f;
          line-height: 18px;
          margin-left: 5px;
        }
        .watchNow {
          display: inline-block;
          width: 60px;
          height: 24px;
          background: linear-gradient(122deg, #ff8d46 0%, #fa5542 100%);
          border-radius: 4px;
          font-weight: 400;
          color: #ffffff;
          font-size: 12px;
          line-height: 24px;
          text-align: center;
          float: right;
          cursor: pointer;
        }
      }
    }
  }
  .empty {
    height: 500px;
    padding-top: 50px;
  }
}
.spanActive {
  width: 100px;
  height: 32px;
  line-height: 32px;
  border-radius: 16px;
  color: @primary-color;
  font-size: 14px;
  text-align: left;
  cursor: pointer;
}
.spanActiveMain {
  width: 120px;
  height: 24px;
  line-height: 24px;
  background: @primary-color;
  border-radius: 16px;
  color: #fff;
  font-size: 14px;
  text-align: center;
  cursor: pointer;
}
</style>
